document.addEventListener("DOMContentLoaded", function () {
  var faqBlock = document.querySelectorAll(".simple-faq");

  faqBlock.forEach(function (block) {
    var faqItems = block.querySelectorAll(".faq-item");

    faqItems.forEach(function (item, index) {
      var answer = item.querySelector(".answer");

      if (index === 0) {
        // Initialize the first item as open
        item.classList.add("faq-active");
        answer.style.height = (answer.scrollHeight + 22) + "px";
      } else {
        // Initialize other items as closed
        item.classList.remove("faq-active");
        answer.style.height = "0px";
      }

      item.addEventListener("click", function () {
        // Toggle the class and height for clicked item
        this.classList.toggle("faq-active");

        if (this.classList.contains("faq-active")) {
          answer.style.height = (answer.scrollHeight + 22) + "px";
        } else {
          answer.style.height = "0px";
        }
      });
    });
  });
});
